import React from 'react';
import _ from 'lodash';

import { ValidateFormFields } from 'Helpers';
import { useEditResquestForm } from 'Hooks';
import { HubsLogbookService } from 'Services';
import { ConvertEditRequestFormToHubsLogbookModel } from 'Components';
import { HubsLogbook } from 'Models';
import { useCallback } from 'react';
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { CAEModal, ErrorModel, Form, FormComponent, Option } from '@cae/component-library';


export interface EditRequestModalProps {
    open: boolean;
    hubsLogbook?: HubsLogbook;
    onClose: () => void;
    onEditRequest?: (HubsLogbook: HubsLogbook) => void;
    isAdmin: boolean;
}
export const EditRequestModal: React.FC<EditRequestModalProps> = ({ open, hubsLogbook, onClose, onEditRequest, isAdmin }) => {
    const { t } = useTranslation("forms");
    const { enqueueSnackbar } = useSnackbar();
    const freshEditRequestForm = useEditResquestForm(t,isAdmin).editRequestForm;
    const [editRequestForm, setEditRequestForm] = React.useState<Form>(_.cloneDeep(freshEditRequestForm));
    const [isOpen, setIsOpen] = React.useState<boolean>(open);
    const [formErrors, setFormErrors] = React.useState<ErrorModel[]>([]);

    React.useEffect(() => {
        setIsOpen(open)
    }, [open]);

    React.useEffect(() => {
        if (hubsLogbook) {
            const editRequestForm = _.cloneDeep(freshEditRequestForm);
            Object.keys(editRequestForm).forEach(editRequestFormKey => {
                if( !(hubsLogbook.status === "PENDING" || isAdmin) && editRequestFormKey !== "status"){
                    editRequestForm[editRequestFormKey].validations = [];
                    editRequestForm[editRequestFormKey].fieldType = "text";
                    editRequestForm[editRequestFormKey].readOnly = true;
                }
                if(editRequestFormKey === "status" && !isAdmin){
                    let option: Option[] = [];
                    editRequestForm[editRequestFormKey].options?.forEach(o => {if( o.value !== "COMPLETED") option.push(o)});
                    editRequestForm[editRequestFormKey].options = option;
                }
                // Don't set the value if it's a legacy issue type
                if ((editRequestFormKey !== "issueType") || (hubsLogbook[editRequestFormKey] !== "Missing parts" && hubsLogbook[editRequestFormKey] !== "Damaged parts" && hubsLogbook[editRequestFormKey] !== "Other")) {
                    editRequestForm[editRequestFormKey].value = hubsLogbook[editRequestFormKey]?.toString() ?? "";
                }
            });
            setEditRequestForm(editRequestForm);
        }
    }, [freshEditRequestForm, hubsLogbook, isAdmin]);

    const handleOnClickClose = React.useCallback(() => {
        setIsOpen(false);
        onClose();
        setFormErrors([])
        setEditRequestForm(_.cloneDeep(freshEditRequestForm));
    }, [onClose, freshEditRequestForm]);

    const handleOnFormSubmit = () => {
        const formErrors = ValidateFormFields(editRequestForm);
        setFormErrors(formErrors);
        
        if (formErrors.length === 0) {
            HubsLogbookService.GetById(hubsLogbook?.id ?? 0).subscribe({
                next: response => SubmitForm(response, editRequestForm),
                error: error => enqueueSnackbar(error.toString(), { variant: "error" })
            }); 
        }
    }

    const SubmitForm = useCallback((hubsLogbook: HubsLogbook, editRequestForm: Form) => {
        HubsLogbookService.EditHubsLogbook(ConvertEditRequestFormToHubsLogbookModel(hubsLogbook, editRequestForm)).subscribe({
            next: editedHubsLogbook =>  {
                if (onEditRequest) {
                    onEditRequest(editedHubsLogbook);
                }
                handleOnClickClose();
            },
            error: error => enqueueSnackbar(error.toString(), { variant: "error" })
        });
    }, [enqueueSnackbar, handleOnClickClose, onEditRequest]);

    return (
        <CAEModal
            actionButtonText="Save"
            actionButtonAction={handleOnFormSubmit}
            cancelButtonText="Cancel"
            cancelButtonAction={handleOnClickClose}
            open={isOpen}
            setOpen={setIsOpen}
            title={`Save Request ${hubsLogbook?.id}`}
            contentType='node'
        >
            <FormComponent form={editRequestForm} errors={formErrors} />
        </CAEModal>
    );
}